import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import {
  VirtualConnectionDownstreamWorkbooksQueryVariables, VirtualConnectionDownstreamWorkbooksQuery, WorkbooksDisplayGridRowDataFragment, VirtualConnectionDownstreamWorkbooksFilteredByTableQueryVariables, VirtualConnectionDownstreamWorkbooksFilteredByTableQuery, WorkbookSortOrder,
  VirtualConnectionDownstreamWorkbooksFilteredByTableDocument,
  VirtualConnectionDownstreamWorkbooksDocument,
} from '../../../../../gen-src/queries';
import { ConnectionListResult, GridSortProps, PaginatedQueryWrapper } from '../../../data-catalog-shared';
import {
  getRowDataForWorkbook,
  WorkbooksDisplayGrid,
  WorkbooksDisplayGridRowData,
} from '../sharedDisplayGrid/WorkbooksDisplayGrid';
import { WorkbooksValidSortFields } from '../sorting/sortProviders/WorkbooksGridSortProvider';

type QueryVariables = VirtualConnectionDownstreamWorkbooksQueryVariables;
type QueryResults = VirtualConnectionDownstreamWorkbooksQuery;
type QueryResultListNode = WorkbooksDisplayGridRowDataFragment;
type GridRowData = WorkbooksDisplayGridRowData;

type QueryVariablesWithFilter = VirtualConnectionDownstreamWorkbooksFilteredByTableQueryVariables;
type QueryResultsWithFilter = VirtualConnectionDownstreamWorkbooksFilteredByTableQuery;
type QueryResultListNodeWithFilter = WorkbooksDisplayGridRowDataFragment;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  const virtualConnection = resultData && resultData.virtualConnections && resultData.virtualConnections[0];
  return virtualConnection ? virtualConnection.downstreamWorkbooksConnection : null;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  const virtualConnection = resultData && resultData.virtualConnections && resultData.virtualConnections[0];
  const virtualConnectionTables = virtualConnection && virtualConnection.tablesConnection && virtualConnection.tablesConnection.nodes;
  const table = virtualConnectionTables && virtualConnectionTables[0];
  return table ? table.downstreamWorkbooksConnection : null;
}

export type VirtualConnectionDownstreamWorkbooksQueryGridProps =
  GridSortProps<WorkbooksValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly filteredTableId: string | null;
    readonly rowCount: number | null;
  };

export function VirtualConnectionDownstreamWorkbooksQueryGrid(props: VirtualConnectionDownstreamWorkbooksQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamWorkbooksLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredWorkbooksLineageGridMessage();

  return props.filteredTableId ? (
    // Query with Selected Field as Filter
    <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionDownstreamWorkbooksFilteredByTableDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        selectedTableId: props.filteredTableId,
        orderBy: props.orderBy as WorkbookSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResultForFilteredQuery}
      mapResultNode={getRowDataForWorkbook}
    >
      {({ rowStore }) => <WorkbooksDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyFilteredGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>
  ) : (
    // Query without Selection
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionDownstreamWorkbooksDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as WorkbookSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForWorkbook}
    >
      {({ rowStore }) => <WorkbooksDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>
  );

}
